var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8729 9.34059L16.0968 1.00568L11.3208 9.34059L16.0968 17.6093L20.8729 9.34059Z",
    fill: "#019DF2",
    stroke: "#0072B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0969 3.64844L12.8432 9.32665L16.0969 14.9598L19.3506 9.32665L16.0969 3.64844Z",
    fill: "#019DF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6723 9.83393L1.06606 9.80264L5.89627 18.1062L15.4452 18.1045L10.6723 9.83393Z",
    fill: "#BEAAF3",
    stroke: "#0072B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35506 11.1244L6.64568 16.7813L13.151 16.7801L9.8994 11.1458L3.35506 11.1244Z",
    fill: "#BEAAF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5225 9.83588L31.1288 9.80459L26.2986 18.1082L16.7496 18.1065L21.5225 9.83588Z",
    fill: "#FF8A4A",
    stroke: "#0072B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8398 11.1264L25.5491 16.7833L19.0438 16.7821L22.2954 11.1477L28.8398 11.1264Z",
    fill: "#FF8A4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3146 27.4543L16.0907 35.7892L20.8667 27.4543L16.0907 19.1856L11.3146 27.4543Z",
    fill: "#8EEA36",
    stroke: "#0072B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0906 33.1465L19.3443 27.4683L16.0906 21.8351L12.8369 27.4683L16.0906 33.1465Z",
    fill: "#8EEA36"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5152 27.168L31.1214 27.1993L26.2912 18.8957L16.7423 18.8975L21.5152 27.168Z",
    fill: "#06BF97",
    stroke: "#0072B0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8324 25.8775L25.5418 20.2206L19.0365 20.2218L22.2881 25.8562L28.8324 25.8775Z",
    fill: "#06BF97"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6655 27.1661L1.05924 27.1974L5.88948 18.8938L15.4384 18.8955L10.6655 27.1661Z",
    fill: "#FCD300",
    stroke: "#0072B0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37948 25.856L6.67012 20.1991L13.1754 20.2003L9.92383 25.8347L3.37948 25.856Z",
    fill: "#FCD300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.4007946a2262bd915d624ab7144e05df.svg";
export { ForwardRef as ReactComponent };